/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";

import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import { Card, CardContent } from "@mui/material";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import { useDispatch, useSelector } from "react-redux";
import Loader from "@jumbo/components/Loader";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { AUDITS } from "app/routes/constant";
import { getAuditHistoryReturnList } from "app/redux/slice/auditHistorySlice";

const AuditList = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();

  const auditData = useSelector((state) => state?.auditHistory);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "uniqueVariant" });

  const columns = [
    {
      id: "date",
      label: "Date",
      sort: true,
      render: (elm) => <> {moment(elm?.date).format("DD/MM/YYYY")}</>,
    },
    {
      id: "productId",
      label: "Product",
      render: (row) => <>{row?.productId?.name || "-"}</>,
    },
    {
      id: "variantId",
      label: "Variant",
      render: (row) => <>{row?.variantId?.name || "-"}</>,
    },
    {
      id: "fabricId",
      label: "Fabric",
      render: (row) => <>{row?.fabricId?.name || "-"}</>,
    },
    {
      id: "poId",
      label: "PO",
      render: (row) => <>{row?.poId?.poNo || "-"}</>,
    },
    {
      id: "invoiceId",
      label: "Invoice",
      render: (row) => <>{row?.invoiceId?.invoiceNumber || "-"}</>,
    },
    {
      id: "billId",
      label: "Bill",
      render: (row) => <>{row?.billId?.billNo || "-"}</>,
    },
    {
      id: "note",
      label: "Note",
      sort: true,
    },
    {
      id: "totalQuantity",
      label: "Total QTY",
      sort: true,
    },
    {
      id: "badQuantity",
      label: "Bad",
      sort: true,
    },
    {
      id: "newFoundQuantity",
      label: "New Found",
      sort: true,
    },
    {
      id: "missingQuantity",
      label: "Missing",
      sort: true,
    },
  ];

  const getData = () => {
    const value = {
      page: page,
      perPage: rowsPerPage,
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getAuditHistoryReturnList({ data: value, id }));
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  return (
    <>
      {auditData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Audit history List
                </Typography>
                <LoadingButton
                  onClick={() => {
                    navigate(AUDITS);
                  }}
                  type="submit"
                  variant="contained"
                  sx={{
                    mt: { xs: 1, md: 0 },
                  }}
                >
                  BacK
                </LoadingButton>
              </Stack>
              <Table
                columns={columns}
                rows={auditData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={auditData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

export default AuditList;
